import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';

import { EndorsesRoutingModule } from './endorses-routing.module';
import { EndorseComponent } from './endorse/endorse.component';
import { AssessmentsModule } from '../assessments/assessments.module';
import { EndorsesService } from './shared/endorses.service';
import { EndorsesComponent } from './endorses.component';
import { EndorseDetailComponent } from './endorse-detail/endorse-detail.component';
import { EndorseDetailSubjectComponent } from './endorse-detail-subject/endorse-detail-subject.component';
import { SetFieldComponent } from './endorse-detail-subject/set-field/set-field.component';
import { SavedEndorseComponent } from './endorse-detail-subject/saved-endorse/saved-endorse.component';
import { SubjectEndorseComponent } from './endorse-detail-subject/saved-endorse/subject-endorse/subject-endorse.component';
import { InformationSavedComponent } from './endorse-detail-subject/saved-endorse/information-saved/information-saved.component';
import { EndorseDetailRecogniseComponent } from './endorse-detail-recognise/endorse-detail-recognise.component';

@NgModule({
  imports: [
    CoreModule,
    AssessmentsModule,
    EndorsesRoutingModule
  ],
  declarations: [EndorseComponent,
     EndorsesComponent, EndorseDetailComponent, EndorseDetailSubjectComponent,
      SetFieldComponent, SavedEndorseComponent, SubjectEndorseComponent, InformationSavedComponent, EndorseDetailRecogniseComponent],
  providers: [EndorsesService],
  entryComponents: [SavedEndorseComponent],
  exports: [EndorseComponent, AssessmentsModule, EndorsesComponent,
    EndorseDetailComponent, EndorseDetailSubjectComponent, SetFieldComponent, SavedEndorseComponent,
    SubjectEndorseComponent, InformationSavedComponent, EndorseDetailRecogniseComponent]
})
export class EndorsesModule { }
